import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

const EcommerceCard = ({ data }) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        cursor: "pointer",
      }}
      onClick={() => {
        if (data.id === "All") {
          navigate("/");
        } else {
          navigate(`/category/${data.id}`);
        }
      }}
    >
      <Box height={200}>
        <img src={data.image} height={"100%"} width={"100%"} alt={data.title} />
      </Box>
      <Box py={1.5} px={1}>
        <Typography variant="h6" fontWeight={600} noWrap>
          {data.title}
        </Typography>

        <Typography
          textAlign={{ xs: "center", sm: "left" }}
          sx={{
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {data.description}
        </Typography>
      </Box>
    </Box>
  );
};

export default EcommerceCard;
